import { AUTH_STEP_TYPE, useAuthNavigation } from '@jusbrasil-web/shared-auth-flows'
import { useCallback } from 'react'

import type { SignupModalHeaderCopy } from '../../experiments/signup-modal/highlight-copy'
import { type UseAuthBaseOptions } from '../../hooks/useAuthBase'
import { useLogin } from '../../hooks/useLogin'
import { PasswordSignIn } from '../password-sign-in'

export interface PasswordStepProps extends Omit<UseAuthBaseOptions, 'initialEmail'> {
  email: string
  onCloseClick?: () => void
  onAuthSuccess?: () => void
  signupModalHeader?: SignupModalHeaderCopy
}

export function PasswordStep({
  email,
  onCloseClick,
  signupModalHeader,
  ...authOptions
}: PasswordStepProps) {
  const navigate = useAuthNavigation()
  const { isLoading, error, handlePasswordSubmit } = useLogin({
    initialEmail: email,
    ...authOptions,
  })

  const handleBackToEmail = useCallback(() => {
    navigate({ type: AUTH_STEP_TYPE.EMAIL })
  }, [navigate])

  const handleForgotPassword = useCallback(() => {
    navigate({ type: AUTH_STEP_TYPE.RECOVERY, email })
  }, [navigate, email])

  return (
    <PasswordSignIn
      email={email}
      isLoading={isLoading}
      error={error}
      signupModalHeader={signupModalHeader}
      onSubmit={handlePasswordSubmit}
      onBackToEmail={handleBackToEmail}
      onForgotPassword={handleForgotPassword}
      onCloseClick={onCloseClick}
    />
  )
}
